import client from "../../../../services/session/apiClient";
import presignedExport from "../../../../services/auth/presignedExport";

/**
 * GET  /localPages/localPagesTemplates                              
 * @api.v5.controllers.LocalPagesInternalApiController.localPagesTemplates(offset: Int, limit: Int, _ids: Seq[String], accountIds: Seq[String], brandIds: Seq[String])

 * @param offset
 * @param limit
 * @param accountId
 * @returns {*}
 */
export function loadLocalPagesTemplates(offset, limit, accountId) {
    return client.get('/localPages/localPagesTemplates', {
        params: {offset: offset, limit: limit, accountIds: [accountId]}
    }).then(resp => resp.data)
}

export function downloadTemplateJson(templateId) {
  return presignedExport.downloadExport(`/localPages/template/${templateId}/download`);
}

export function uploadTemplateJson(templateJsonFile) {
    return client.post('/localPages/template/upload', templateJsonFile);
}

export function localPagesContents(offset, limit, locationIds, templateIds, brandIds) {
    return client.get('/v5/localPages/localPagesContents', {
        params: {offset: offset, limit: limit, locationIds: locationIds, templateIds: templateIds, brandIds: brandIds}
    }).then(resp => resp.data)
}

export function contentsCount(templateIds) {
    return client.get('/localPages/template/count', {
        params: {templateIds: templateIds}
    }).then(resp => resp.data)
}

export function createDefaultLocalPagesContent({locationId: locationId, templateId: templateId, brandId: brandId, vendor: vendor, published: published}) {
    return client.post('/v5/localPages/content/create',
        {locationId: locationId, templateId: templateId, brandId: brandId, vendor: vendor, published: published}
    )
        .then(resp => resp.data)
}

export function saveLocalPagesTemplate(localPagesTemplate) {
    client.post(`/v5/localPages/template/update/${localPagesTemplate._id}`, localPagesTemplate)
}

export function localPagesReport({offset = 0, limit = 0, entityIds = [], templateIds = [], brandIds = [], publishedStatus}) {
    return client.get('/v5/localPages/localPagesContentReport', {
        params: {
            offset,
            limit,
            entityIds,
            templateIds,
            brandIds,
            publishedStatus
        }
    }).then(resp => resp.data)
}

export async function localPagesReportCount({entityIds, templateIds, brandIds, publishedStatus}) {
    const resp = await client.get('/v5/localPages/countLocalPagesReport', {
        params: {
            entityId: entityIds,
            templateIds,
            brandIds,
            publishedStatus
        }
    });
    return resp.data;
}

export function downloadLocalPagesReport({offset = 0, limit = 1000000, entityIds = [], templateIds = [], brandIds = [], publishedStatus}) {
    return  presignedExport.downloadExport('/v5/localPages/exportLocalPagesContentReport',  {
            offset: offset,
            limit: limit,
            entityIds: entityIds,
            templateIds: templateIds,
            brandIds: brandIds,
            publishedStatus: publishedStatus
    }, {
        arrayFormat: 'repeat'
    }).then((resp) => {
        return resp;
    });
}

export function deleteLocalPagesTemplate(localPagesTemplate) {
    return client.delete(`/v5/localPages/template/delete/${localPagesTemplate._id}`)
        .then(response => response)
}

export function createLocalPagesTemplate(name, brandIds, vendor, sections) {
    return client.post('/v5/localPages/template/create', {
        name: name,
        brandIds: brandIds,
        vendor: vendor,
        sections: sections
    }).then(response => response.data)

}

export function localPagesBrands({offset, limit, accountIds, vendorIds, brandIds, brandName, vendorName}) {
    return client.get('/localPages/localPagesBrands', {
        params: {
            offset: offset,
            limit: limit,
            _ids: brandIds,
            names: brandName,
            vendorNames: vendorName,
            vendorIds: vendorIds,
            accountIds: accountIds
        }
    }).then(resp => resp.data)
}

export function updateLocalPagesBrand(localPagesBrand) {
    return client.post(`/v5/localPages/brand/update/${localPagesBrand.vendorId}`, localPagesBrand)
        .then(response => response.data)
}

/**
 * POST          /v5/localPages/brand/create                                     @api.v5.controllers.LocalPagesController.createLocalPagesBrand
 * @param localPagesBrand
 * @returns {*}
 */

export function createLocalPagesBrand(localPagesBrand) {
    return client.post("/v5/localPages/brand/create", localPagesBrand)
        .then(response => response.data)
}


/**
 * POST          /v5/localPages/localPagesUploader/uploadCsv                     @api.v5.controllers.LocalPagesController.uploadCsv
 * @param file
 * @returns {*}
 */


export function uploadLocalPagesCsv(localPagesCsv) {
    return client.post("/v5/localPages/localPagesUploader/uploadCsv", localPagesCsv)
        .then(response => response.data)
}